module.exports = __webpack_public_path__ + "static/img/shanghai0.02a7027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shanghai0.png
// module id = xmAd
// module chunks = 1